<template>
	<section>
		<v-layout row>
			<v-flex xs12>
				<v-tabs
					background-color="transparent"
					v-model="tab"
					class="transparent"
				>
					<v-tabs-slider color="primary"></v-tabs-slider>
					<v-tab>
						Muestras
					</v-tab>
					<v-tab>
						PCR
					</v-tab>
				</v-tabs>
			</v-flex>
		</v-layout>
		<section v-show="tab == 0">
			<v-layout row class="mt-4">
				<v-flex xs12 md2>
					<v-autocomplete
						@change="mostrarMuestras"
						outlined
						label="Estado"
						item-value="MuestraEstadoID"
						item-text="MuestraEstado"
						:items="catalogos.MuestrasEstados"
						v-model="filtros.MuestraEstadoID"
					>
					</v-autocomplete>
				</v-flex>
				<v-flex xs12 md2>
					<v-autocomplete
						@change="mostrarMuestras"
						clearable
						outlined
						label="Tipo de Análisis"
						item-value="AnalisisTipoID"
						item-text="AnalisisTipo"
						:items="catalogos.AnalisisTipos"
						v-model="filtros.AnalisisTipoID"
					>
					</v-autocomplete>
				</v-flex>

				<v-flex xs12 md2>
					<v-menu
						ref="fechaInicio"
						:close-on-content-click="false"
						:nudge-right="40"
						transition="scale-transition"
						offset-y
						min-width="290px"
					>
						<template v-slot:activator="{ on }">
							<v-text-field
								outlined
								v-on="on"
								label="Fecha Inicio"
								slot="activator"
								:value="formatDate(filtros.FechaInicio)"
								prepend-icon="event"
								readonly
							></v-text-field>
						</template>
						<v-date-picker
							@change="mostrarMuestras"
							@input="$refs.fechaInicio.save(filtros.FechaInicio)"
							locale="es-es"
							v-model="filtros.FechaInicio"
							scrollable
						></v-date-picker>
					</v-menu>
				</v-flex>
				<v-flex xs12 md2>
					<v-menu
						ref="fechaFin"
						:close-on-content-click="false"
						:nudge-right="40"
						transition="scale-transition"
						offset-y
						min-width="290px"
					>
						<template v-slot:activator="{ on }">
							<v-text-field
								outlined
								v-on="on"
								label="Fecha Fin"
								slot="activator"
								:value="formatDate(filtros.FechaFinal)"
								prepend-icon="event"
								readonly
							></v-text-field>
						</template>
						<v-date-picker
							@change="mostrarMuestras"
							@input="$refs.fechaFin.save(filtros.FechaFinal)"
							locale="es-es"
							v-model="filtros.FechaFinal"
							scrollable
						></v-date-picker>
					</v-menu>
				</v-flex>
				<v-flex xs12 md4 class="text-right">
					<v-menu offset-y>
						<template v-slot:activator="{ on }">
							<v-btn v-on="on" color="primary" class="mr-5"
								><v-icon>add</v-icon> Procesar Muestras</v-btn
							>
						</template>
						<v-list>
							<v-list-item link @click.prevent="cargarMuestras">
								<v-list-item-title>Cargar Muestras</v-list-item-title>
							</v-list-item>
							<v-divider></v-divider>
							<v-list-item link @click.prevent="extraccion">
								<v-list-item-title>Extracción</v-list-item-title>
							</v-list-item>
							<v-list-item link @click.prevent="nuevoPCR">
								<v-list-item-title>Pre-PCR</v-list-item-title>
							</v-list-item>
							<v-divider></v-divider>
							<v-list-item link @click.prevent="pruebasRapidas(null)">
								<v-list-item-title>Pruebas Rápidas</v-list-item-title>
							</v-list-item>
						</v-list>
					</v-menu>
				</v-flex>
			</v-layout>
			<v-layout row class="mt-4">
				<v-flex xs12>
					<v-card>
						<v-card-text>
							<v-data-table :items="muestras" :items-per-page="25" fixed-header>
								<template slot="header">
									<tr class="mb-6">
										<th width="100" class="primary--text text-left">
											Código
										</th>
										<th class="primary--text text-left">
											Tipo Análisis
										</th>
										<th class="primary--text text-left">
											Fecha Toma
										</th>
										<th class="primary--text text-left">
											Último Movimiento
										</th>
										<th class="primary--text text-left">
											Estátus
										</th>
										<th></th>
									</tr>
								</template>
								<template slot="item" slot-scope="scope">
									<tr>
										<td>{{ scope.item.CodigoBarras }}</td>
										<td>{{ scope.item.AnalisisTipo }}</td>
										<td>
											{{ formatDate(scope.item.FechaMuestra.split("T")[0]) }}
										</td>
										<td>
											{{
												scope.item.FechaUltimoMovimiento
													? formatDate(
															scope.item.FechaUltimoMovimiento.split("T")[0]
													  )
													: ""
											}}
										</td>
										<td>{{ scope.item.Estatus }}</td>
										<td class="text-right">
											<v-tooltip
												bottom
												v-if="
													scope.item.MuestraEstadoID === 2 &&
														(scope.item.AnalisisTipoID === 2 ||
															scope.item.AnalisisTipoID === 3)
												"
											>
												<template v-slot:activator="{ on }">
													<v-btn
														v-on="on"
														icon
														@click.prevent="
															pruebasRapidas(scope.item.CodigoBarras)
														"
													>
														<v-icon color="primary">check</v-icon>
													</v-btn>
												</template>
												<span>Validar</span>
											</v-tooltip>
											<v-tooltip bottom>
												<template v-slot:activator="{ on }">
													<v-btn
														v-on="on"
														class="ml-4"
														icon
														@click.prevent="
															verMuestra(scope.item.MuestraDetalleID)
														"
													>
														<v-icon color="primary">visibility</v-icon>
													</v-btn>
												</template>
												<span>Ver Info</span>
											</v-tooltip>
										</td>
									</tr>
								</template>
								<template slot="no-data">
									No hay datos para mostrar
								</template>
							</v-data-table>
						</v-card-text>
					</v-card>
				</v-flex>
			</v-layout>
		</section>
		<section v-show="tab === 1">
			<v-layout row class="mt-4">
				<v-flex xs12 md2>
					<v-autocomplete
						@change="mostrarPCR"
						outlined
						clearable
						label="Estatus"
						item-value="MuestraEstatusID"
						item-text="Estatus"
						:items="catalogos.MuestrasEstatus"
						v-model="filtrosPCR.MuestraEstatusID"
					>
					</v-autocomplete>
				</v-flex>
				<v-flex xs12 md2>
					<v-menu
						ref="fechaInicioPCR"
						:close-on-content-click="false"
						:nudge-right="40"
						transition="scale-transition"
						offset-y
						min-width="290px"
					>
						<template v-slot:activator="{ on }">
							<v-text-field
								outlined
								v-on="on"
								label="Fecha Inicio"
								slot="activator"
								:value="formatDate(filtrosPCR.FechaInicio)"
								prepend-icon="event"
								readonly
							></v-text-field>
						</template>
						<v-date-picker
							@change="mostrarPCR"
							@input="$refs.fechaInicioPCR.save(filtrosPCR.FechaInicio)"
							locale="es-es"
							v-model="filtrosPCR.FechaInicio"
							scrollable
						></v-date-picker>
					</v-menu>
				</v-flex>
				<v-flex xs12 md2>
					<v-menu
						ref="fechaFinPCR"
						:close-on-content-click="false"
						:nudge-right="40"
						transition="scale-transition"
						offset-y
						min-width="290px"
					>
						<template v-slot:activator="{ on }">
							<v-text-field
								outlined
								v-on="on"
								label="Fecha Fin"
								slot="activator"
								:value="formatDate(filtrosPCR.FechaFinal)"
								prepend-icon="event"
								readonly
							></v-text-field>
						</template>
						<v-date-picker
							@change="mostrarPCR"
							@input="$refs.fechaFinPCR.save(filtrosPCR.FechaFinal)"
							locale="es-es"
							v-model="filtrosPCR.FechaFinal"
							scrollable
						></v-date-picker>
					</v-menu>
				</v-flex>
			</v-layout>
			<v-layout row class="mt-4">
				<v-flex xs12>
					<v-card>
						<v-card-text>
							<v-data-table :items="pcrs">
								<template slot="header">
									<tr class="mb-6">
										<th class="primary--text text-left">
											Folio
										</th>
										<th class="primary--text text-left">
											Fecha
										</th>
										<th class="primary--text text-left">
											Hora
										</th>
										<th class="primary--text text-left">
											Kit
										</th>
										<th class="primary--text text-left">
											Estatus
										</th>
										<th class="primary--text text-left">
											Resultados Positivos
										</th>
										<th class="primary--text text-left">
											Resultados Negativos
										</th>
										<th class="primary--text text-left">
											Resultados Inválidos
										</th>
										<th class="primary--text text-left"></th>
									</tr>
								</template>
								<template slot="item" slot-scope="scope">
									<tr>
										<td>{{ scope.item.PCRID }}</td>
										<td>{{ fechaSQL(scope.item.FechaRegistro) }}</td>
										<td>{{ horaSQL(scope.item.FechaRegistro) }}</td>
										<td>{{ scope.item.Kit }}</td>
										<td>{{ scope.item.Estatus }}</td>
										<td>
											{{
												scope.item.MuestraEstatusID === 5
													? "-"
													: scope.item.ResultadosPositivos
											}}
										</td>
										<td>
											{{
												scope.item.MuestraEstatusID === 5
													? "-"
													: scope.item.ResultadosNegativos
											}}
										</td>
										<td>
											{{
												scope.item.MuestraEstatusID === 5
													? "-"
													: scope.item.ResultadosInvalidos
											}}
										</td>
										<td class="text-right">
											<v-tooltip
												bottom
												v-if="scope.item.MuestraEstatusID === 5"
											>
												<template v-slot:activator="{ on }">
													<v-btn
														small
														v-on="on"
														icon
														class=""
														@click.prevent="
															descargarArchivo(scope.item.PrePCRCSV)
														"
													>
														<v-icon color="primary">file_download</v-icon>
													</v-btn>
												</template>

												<span>Descargar CSV</span>
											</v-tooltip>

											<input
												accept=".csv,.xls,.xlsx"
												type="file"
												v-show="false"
												:ref="'csvInput' + scope.item.PCRID"
												@change="subirArchivo($event, scope.item.PCRID)"
											/>

											<v-tooltip
												bottom
												v-if="scope.item.MuestraEstatusID === 5"
											>
												<template v-slot:activator="{ on }">
													<v-btn
														v-on="on"
														icon
														small
														@click.prevent="adjuntarCsv(scope.item.PCRID)"
													>
														<v-icon color="primary">file_upload</v-icon>
													</v-btn>
												</template>
												<span>Subir CSV</span>
											</v-tooltip>

											<v-tooltip
												bottom
												v-if="scope.item.MuestraEstatusID === 5"
											>
												<template v-slot:activator="{ on }">
													<v-btn
														v-on="on"
														icon
														small
														@click.prevent="
															precargarResultados(scope.item.PCRID)
														"
													>
														<v-icon color="primary">file_copy</v-icon>
													</v-btn>
												</template>
												<span>Precargar Resultados</span>
											</v-tooltip>

											<v-tooltip
												bottom
												v-if="
													scope.item.MuestraEstatusID === 6 ||
														scope.item.MuestraEstatusID === 7
												"
											>
												<template v-slot:activator="{ on }">
													<v-btn
														small
														v-on="on"
														icon
														class="mr-1"
														@click.prevent="regresarEstatus(scope.item)"
													>
														<v-icon color="primary">history</v-icon>
													</v-btn>
												</template>
												<span>Regresar Estatus</span>
											</v-tooltip>
											<v-tooltip
												bottom
												v-if="scope.item.MuestraEstatusID === 5"
											>
												<template v-slot:activator="{ on }">
													<v-btn
														small
														v-on="on"
														icon
														v-if="scope.item.MuestraEstatusID === 5"
														class="mr-1"
														@click.prevent="verResultados(scope.item)"
													>
														<v-icon color="primary">visibility</v-icon>
													</v-btn>
												</template>
												<span>Ver Carga</span>
											</v-tooltip>

											<v-tooltip
												bottom
												v-else-if="scope.item.MuestraEstatusID == 6"
											>
												<template v-slot:activator="{ on }">
													<v-btn
														v-on="on"
														icon
														small
														@click.prevent="verResultados(scope.item)"
													>
														<v-icon color="primary">check</v-icon>
													</v-btn>
												</template>
												<span>Validar Resultados</span>
											</v-tooltip>

											<v-tooltip v-else bottom>
												<template v-slot:activator="{ on }">
													<v-btn
														v-on="on"
														icon
														small
														@click.prevent="verResultados(scope.item)"
													>
														<v-icon color="primary">visibility</v-icon>
													</v-btn>
												</template>

												<span>Ver Resultados</span>
											</v-tooltip>
										</td>
									</tr>
								</template>
								<template slot="no-data">
									No hay datos para mostrar
								</template>
							</v-data-table>
						</v-card-text>
					</v-card>
				</v-flex>
			</v-layout>
		</section>
		<carga-muestras v-if="mostrarCarga" @cerrar="cerrarCarga"></carga-muestras>
		<extraccion
			v-if="mostrarExtraccion"
			@cerrar="cerrarExtraccion"
		></extraccion>
		<pruebas-rapidas
			:codigoBarras="codigoBarrasSeleccionado"
			v-if="mostrarPruebasRapidas"
			@cerrar="cerrarPruebasRapidas"
		>
		</pruebas-rapidas>
		<v-dialog width="30%" v-model="mostrarMuestra">
			<v-card>
				<v-card-title class="text-h3 primary--text">
					Info. Muestra
				</v-card-title>
				<v-card-text>
					<v-container grid-list-md v-if="infoMuestra">
						<v-layout row wrap>
							<v-flex xs4 class="text-right font-weight-bold">
								Código Muestra:
							</v-flex>
							<v-flex xs8> {{ infoMuestra.CodigoBarras }} </v-flex>
							<v-flex xs4 class="text-right font-weight-bold">
								Fecha Toma:
							</v-flex>
							<v-flex xs8> {{ fechaSQL(infoMuestra.FechaToma) }} </v-flex>
							<v-flex xs4 class="text-right font-weight-bold">
								Hora Toma:
							</v-flex>
							<v-flex xs8> {{ horaSQL(infoMuestra.FechaToma) }} </v-flex>
							<v-flex xs4 class="text-right font-weight-bold">
								Es Repetición:
							</v-flex>
							<v-flex xs8>
								{{ infoMuestra.EsRepeticion ? "SI" : "NO" }}
							</v-flex>
							<v-flex xs4 class="text-right font-weight-bold">
								Estatus:
							</v-flex>
							<v-flex xs8> {{ infoMuestra.Estatus }} </v-flex>
							<v-flex xs4 class="text-right font-weight-bold">
								Estado Muestra:
							</v-flex>
							<v-flex xs8> {{ infoMuestra.MuestraEstado }} </v-flex>
						</v-layout>
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>
	</section>
</template>

<script>
import CargaMuestras from "./CargaMuestras.vue";
import Extraccion from "./Extraccion.vue";
import PruebasRapidas from "./PruebasRapidas.vue";
import ServicioCatalogos from "../../services/catalogos";
import ServicioLaboratorio from "../../services/laboratorio";
import ServicioUpload from "../../services/upload";
export default {
	components: { CargaMuestras, Extraccion, PruebasRapidas },
	name: "laboratorio",
	methods: {
		async precargarResultados(pcrID) {
			this.confirmar(
				"Precargar Resultados",
				"Ingrese contraseña",
				"Contraseña",
				true
			).then(async (pw) => {
				const res = await ServicioLaboratorio.procesarPCRManual(pcrID, pw);
				if (res.data.result === 1) {
					this.$root.mensajeExito = "El PCR se procesó con éxito.";
					await this.mostrarPCR();
				} else {
					this.$root.mensajeError = res.data.message;
				}
			});
		},
		async regresarEstatus(pcr) {
			this.confirmar(
				"Regresar Estátus",
				"Desea regresar el estátus de la muestra?"
			).then(async () => {
				const res = await ServicioLaboratorio.regresarEstatus(pcr.PCRID);
				if (res.data.result === 1) {
					this.$root.mensajeExito =
						"El estátus del PCR se modificó correctamente.";
					await this.mostrarPCR();
				} else {
					this.$root.mensajeError = res.data.message;
				}
			});
		},
		descargarArchivo(archivo) {
			window.open(this.config.RutaCSVPrePCR + archivo, "_blank");
		},
		async verMuestra(muestraDetalleID) {
			const res = await ServicioLaboratorio.infoMuestra(muestraDetalleID);
			this.infoMuestra = res.data.data.Table0[0];
			this.mostrarMuestra = true;
		},
		async mostrarMuestras() {
			this.respaldarFiltros();
			const filtros = {
				AnalisisTipoID: this.filtros.AnalisisTipoID ?? 0,
				MuestraEstadoID: this.filtros.MuestraEstadoID ?? 0,
				FechaInicio: `${this.filtros.FechaInicio}T00:00:00`,
				FechaFinal: `${this.filtros.FechaFinal}T23:59:59`,
			};
			const res = await ServicioLaboratorio.reporteMuestras(filtros);
			this.muestras = res.data.data.Table0;
		},
		pruebasRapidas(codigo) {
			this.codigoBarrasSeleccionado = codigo;
			this.mostrarPruebasRapidas = true;
		},
		cerrarPruebasRapidas(muestras) {
			if (muestras) {
				this.$root.mensajeExito = "Las muestras se procesaron con éxito";
				this.mostrarMuestras();
			}
			this.mostrarPruebasRapidas = false;
		},
		cerrarExtraccion(muestras) {
			if (muestras) {
				this.$root.mensajeExito = "La extracción se registró con éxito";
				this.mostrarMuestras();
			}
			this.mostrarExtraccion = false;
		},
		cerrarCarga(muestras) {
			if (muestras) {
				this.$root.mensajeExito = "La carga de muestras se registró con éxito";
				this.mostrarMuestras();
			}
			this.mostrarCarga = false;
		},
		cargarMuestras() {
			this.mostrarCarga = true;
		},
		adjuntarCsv(pcrID) {
			this.$refs[`csvInput${pcrID}`].click();
		},
		nuevoPCR() {
			this.respaldarFiltros();
			this.$router.push("/digitrack/pcr");
		},
		cargarGradilla() {
			this.respaldarFiltros();
			this.$router.push("/digitrack/carga-gradillas");
		},
		extraccion(codigoGradilla) {
			this.mostrarExtraccion = true;
		},
		prePCR(codigoGradilla) {
			this.respaldarFiltros();
			this.$router.push("/digitrack/pre-pcr/" + codigoGradilla);
		},
		verGradilla(codigoGradilla) {
			this.respaldarFiltros();
			this.$router.push("/digitrack/ver-gradillas/" + codigoGradilla);
		},
		verResultados(pcr) {
			this.respaldarFiltros();
			const { PCRID, MuestraEstatusID } = pcr;
			this.$router.push("/digitrack/pcr/" + PCRID + "/" + MuestraEstatusID);
		},
		async mostrarPCR() {
			this.respaldarFiltros();
			console.log(this.filtrosPCR);
			const filtros = {
				MuestraEstatusID: this.filtrosPCR.MuestraEstatusID ?? 0,
				FechaInicio: `${this.filtrosPCR.FechaInicio}T00:00:00`,
				FechaFinal: `${this.filtrosPCR.FechaFinal}T23:59:59`,
			};

			const res = await ServicioLaboratorio.reportePCR(filtros);
			this.pcrs = res.data.data.Table0;
		},
		async cargarCatalogos() {
			let res = await ServicioCatalogos.getMuestrasEstados();
			this.catalogos.MuestrasEstados = res.data.data.Table0;
			res = await ServicioCatalogos.getAnalisisTipos();
			this.catalogos.AnalisisTipos = res.data.data.Table0;
			res = await ServicioCatalogos.getMuestrasEstatus();
			this.catalogos.MuestrasEstatus = res.data.data.Table0.filter(
				(e) => [5, 6, 7].indexOf(e.MuestraEstatusID) > -1
			);
		},
		async subirArchivo(ev, pcrID) {
			if (ev.target.files.length) {
				const archivo = ev.target.files[0];
				const res = await ServicioUpload.uploadCSV(archivo);
				if (res.data.result === 1) {
					const nuevoArchivo = res.data.data.Table0[0].nuevo;
					const resPCR = await ServicioLaboratorio.procesarPCR(
						nuevoArchivo,
						pcrID
					);

					if (resPCR.data.result === 1) {
						this.$root.mensajeExito = "El PCR se procesó con éxito";
						await this.mostrarPCR();
					} else {
						this.$root.mensajeError =
							"Error al procesar PCR " + resPCR.data.message;
					}
				} else {
					this.$root.mensajeError =
						"Error al subir el archivo " + res.data.message;
				}
			}
		},

		respaldarFiltros() {
			localStorage.setItem(
				"lab-filtros-muestras",
				JSON.stringify(this.filtros)
			);
			localStorage.setItem("lab-filtros-pcr", JSON.stringify(this.filtrosPCR));
		},
	},
	async mounted() {
		const hoy = this.fechaPicker(this.$root.hoy);
		this.filtros.FechaInicio = hoy;
		this.filtros.FechaFinal = hoy;
		this.filtrosPCR.FechaInicio = hoy;
		this.filtrosPCR.FechaFinal = hoy;
		await this.cargarCatalogos();
		this.filtros.MuestraEstadoID = this.catalogos.MuestrasEstados[1].MuestraEstadoID;

		let filtros;
		if (
			localStorage.getItem("lab-filtros-muestras") ||
			localStorage.getItem("lab-filtros-pcr")
		) {
			let filtrosMuestras = localStorage.getItem("lab-filtros-muestras");
			let filtrosPCR = localStorage.getItem("lab-filtros-pcr");
			if (filtrosMuestras) {
				filtros = JSON.parse(filtrosMuestras);
				this.filtros = filtros;
			}
			if (filtrosPCR) {
				filtros = JSON.parse(filtrosPCR);
				this.filtrosPCR = filtros;
			}
		}

		this.$nextTick(async () => {
			await this.mostrarMuestras();
			await this.mostrarPCR();
			if (this.$route.params.tab) {
				this.tab = parseInt(this.$route.params.tab);
			}
		});
	},
	data() {
		return {
			codigoBarrasSeleccionado: null,
			infoMuestra: null,
			mostrarPruebasRapidas: false,
			mostrarMuestra: false,
			mostrarExtraccion: false,
			mostrarCarga: false,
			tab: 0,
			filtros: {
				MuestraEstadoID: null,
				AnalisisTipoID: null,
				FechaInicio: null,
				FechaFinal: null,
			},
			filtrosPCR: {
				MuestraEstatusID: null,
				FechaInicio: null,
				FechaFinal: null,
			},
			catalogos: {
				MuestrasEstados: [],
				AnalisisTipos: [],
				MuestrasEstatus: [],
			},
			muestras: [],
			pcrs: [],
		};
	},
};
</script>
